// import config from 'config';

const config = {
  // host: 'https://fms-us-pre.didiglobal.com'
  // host: 'https://gsapi-sim100-us01-test.intra.xiaojukeji.com'
  // host: 'https://dsim213-api.intra.xiaojukeji.com',
  host: 'https://fms-union.didiglobal.com'
};

export const PageUrl = {
  // TCUrl: 'https://privacycenter.didiglobal.com/MX/privacy-notice/1d98acd0e2bf8ed69f6f892c2e1bbc02/Mexico',
  DriverRegister: 'https://page.didiglobal.com/driver-page/register/index.html',
  CarRegister: 'https://page.didiglobal.com/driver-page/mycars/index.html',
  fleetAPP: 'https://fleetapp.didiglobal.com/'
};

export const CommonUrl = {
  // 登录校验
  CheckRole: `${config.host}/fleet/web/personal/checkRole`,
  // 公共接口 时区、货币单位
  TimeOrUnit: `${config.host}/fleet/web/format/Dict/getTimeOrUnit`,
  GETBILLSWITCH: `${config.host}/fleet/web/common/feature/set`, // 获取功能开关接口
  // 配置相关
  // 司机市场-车头个人中心配置
  ConfigFleetMineCenter: `${config.host}/fleet/web/common/personal/getFleetCenterForFe`,
  // 司机市场-个人中心设置配置
  ConfigFleetSettings: `${config.host}/fleet/web/common/personal/getFleetSettingsForFe`,
  // 司机市场-上架车辆配置
  ConfigOnShelf: `${config.host}/fleet/web/common/personal/getVehicleOnShelfForFe`,
  // 司机市场配置
  ConfigDriverMarket: `${config.host}/fleet/web/common/recommend/driverMarketForFe`,
  // 车辆详情配置
  ConfigVehicleDetail: `${config.host}/fleet/web/common/recommend/carDetailForFe`,

  // 车头侧会话详情配置
  ConfigFleetMsgForFe: `${config.host}/fleet/web/common/im/getFleetMsgForFe`,

  // 车辆市场-司机个人中心配置
  ConfigDriverMineCenter: `${config.host}/fleet/web/common/personal/getDriverCenterForFe`,
  // 车辆市场-个人中心设置配置
  ConfigDriverSettings: `${config.host}/fleet/web/common/personal/getDriverSettingsForFe`,
  // 车辆市场-司机简历配置
  ConfigDriverResume: `${config.host}/fleet/web/common/personal/getDriverResumeForFe`,
  // 车辆市场配置
  ConfigVehicleMarket: `${config.host}/fleet/web/common/recommend/carMarketForFe`,
  // 车辆市场-广告位
  ConfigVehicleBanner: `${config.host}/fleet/web/common/recommend/getVehicleMarketBannerForFe`,

  // 司机侧会话详情配置
  ConfigDriverMsgForFe: `${config.host}/fleet/web/common/im/getDriverMsgForFe`,
  // 邀请详情配置，暂时未使用
  ConfigInviteDetail: `${config.host}/fleet/web/common/recommend/getInviteDetailForFe`,

  // 合规接口-检测合规
  CheckLegalNotice: `${config.host}/fleet/web/personal/getDriverLegalNotice`,
  // 合规接口-确认合规
  AgreeLegalNotice: `${config.host}/fleet/web/personal/agreeLegalNotice`,

  // 行为 入口跳转
  DriverBehavior: `${config.host}/fleet/web/personal/getDriverBehavior`,
  SaveDriverBehavior: `${config.host}/fleet/web/personal/saveDriverBehavior`,

  // 图片审核
  PictureAuditStatus: `${config.host}/fleet/web/common/security/getPictureAuditStatus`
};

export const DriverCenterUrl = {
  // 车头信息
  // FleetInfo: `${config.host}/fleet/web/personal/getFleetInfo`, // 弃用
  // 上传头像
  UploadFleetPortrait: `${config.host}/fleet/web/driver/uploadFleetPortrait`,
  // 车辆列表
  CarList: `${config.host}/fleet/web/personal/getCarList`,
  // 三种类型车辆列表数目
  CarCount: `${config.host}/fleet/web/personal/getCarCount`,
  // 上传车辆图片
  UploadVehiclePicture: `${config.host}/fleet/web/common/uploadVehiclePicture`,
  // 上架车辆
  PutVehicleOnSelf: `${config.host}/fleet/web/car/putVehicleOnShelf`,
  // 下架车辆
  PutCarOffShelf: `${config.host}/fleet/web/personal/putCarOffShelf`,
  // 车型系列列表
  // VehicleBrandNames: `${config.host}/fleet/web/car/getVehicleBrandName`,
  // 车型系列型号
  // VehicleSeries: `${config.host}/fleet/web/car/getVehicleSeriesByBrandName`,
  // 上架车辆详情
  VehicleDetail: `${config.host}/fleet/web/car/getVehicleOnShelfInfo`,
  // 查询租金费项列表
  RentConfig: `${config.host}/fleet/web/bill/rentConfig`,
  // 查询车头资金流模式
  FundMode: `${config.host}/fleet/web/bill/fundMode`,
  // 改变车头资金流模式
  FundModeModify: `${config.host}/fleet/web/bill/fundMode/modify`,
  // 新资金流 - 获取最大可设置的金额
  MaxSettingAmount: `${config.host}/fleet/web/bill/maxSettingAmount`,
  // 是否未曾上架车辆
  CheckDriverEdited: `${config.host}/fleet/web/driver/checkFirstOnShelf`,
  // 保存车头推荐信息
  SaveRecommendFleetInfo: `${config.host}/fleet/web/driver/saveRecommendFleetInfo`,
  // 获取车头推荐信息
  RecommendFleetInfo: `${config.host}/fleet/web/driver/getRecommendFleetInfo`,
  // 运营城市列表
  OpenCityList: `${config.host}/fleet/web/common/openCityList`,
  // 推荐车辆列表
  RecomDriverList: `${config.host}/fleet/web/recommend/driver/getDriverList`,
  // 司机详情
  CenterDriverDetail: `${config.host}/fleet/web/recommend/driver/getDriverDetail`,
  // 司机位置地图
  CenterDriverMapUrl: `${config.host}/fleet/web/recommend/driver/getDriverMapUrl`,
  // 获取司机简历信息
  RecommendDriverResume: `${config.host}/fleet/web/personal/getRecommendDriverResume`,
  // 收藏司机
  MarkDriver: `${config.host}/fleet/web/recommend/driver/markDriver`,
  // 建立虚拟号码
  VirtualPhone: `${config.host}/fleet/web/phone/getVirtualPhone`,
  // 车辆审核状态
  VehicleStatus: `${config.host}/fleet/web/car/getVehicleStatusByCarId`,

  // 消息列表
  GetMsgByDialogueId: `${config.host}/fleet/web/im/getMsgByDialogueId`,
  // 发送消息
  SendMsg: `${config.host}/fleet/web/im/sendMsg`,
  // 会话列表
  FleetMessageList: `${config.host}/fleet/web/im/getAllDialogueList`,
  // 更新会话状态
  FleetUploadDialogue: `${config.host}/fleet/web/im/updateDialogueStatus`,
  // 未读消息数
  NewMsgCount: `${config.host}/fleet/web/im/getNewMsgCount`,
  // 创建会话
  AddDialogue: `${config.host}/fleet/web/im/addDialogue`,

  // 建立邀请关系
  RecommendInvite: `${config.host}/fleet/web/im/getRecommendInvite`,
  // 邀请关系详情
  InviteDetail: `${config.host}/fleet/web/im/getInviteDetail`,
  // 确认邀请
  ComfirmInvite: `${config.host}/fleet/web/im/confirmInvite`,
  // 邀请状态
  InviteStatus: `${config.host}/fleet/web/im/getInviteStatus`,

  // 提车地址管理
  // 地址列表
  PickAddressList: `${config.host}/fleet/web/common/address/listPage`,
  // 地址检索
  SearchPickAddress: `${config.host}/fleet/web/common/address/textSearch`,
  // 地址详情
  PickAddressDetail: `${config.host}/fleet/web/common/address/getAddress`,
  // 经纬度解析地址
  ReverseAddress: `${config.host}/fleet/web/common/address/reversePoi`,
  // 地址保存
  SavePickAddress: `${config.host}/fleet/web/common/address/save`,
  // 地址删除
  DeletePickAddress: `${config.host}/fleet/web/common/address/delete`,
  // 获取头像状态
  GetPortraitPermission: `${config.host}/fleet/web/driver/driverPortrait/getPortraitPermission`
};

export const VehicleCenterUrl = {
  // 司机个人信息
  DriverInfo: `${config.host}/fleet/web/personal/getDriverInfo`,
  // 车辆列表
  CarList: `${config.host}/fleet/web/recommend/car/getCarList`,
  // 车辆详情
  CarDetail: `${config.host}/fleet/web/recommend/car/getCarDetail`,
  // 收藏车辆
  MarkCar: `${config.host}/fleet/web/recommend/car/markCar`,
  // 获取司机简历信息
  DriverResume: `${config.host}/fleet/web/personal/getDriverResume`,
  // 保存司机简历信息
  SaveDriverResume: `${config.host}/fleet/web/personal/saveDriverResume`,
  // 推荐车头信息
  RecommendFleetInfo: `${config.host}/fleet/web/driver/getRecommendFleetInfoByPartnerId`,
  // 上架中车辆列表
  OnShelfCarList: `${config.host}/fleet/web/recommend/car/getFleetCarList`,

  // 会话列表
  DriverMessageList: `${config.host}/fleet/web/im/getAllDialogueList`,
  // 会话状态更新
  DriverUploadDialogue: `${config.host}/fleet/web/im/updateDialogueStatus`,

  // 车辆市场入口跳转
  CarMatchEntrance: `${config.host}/fleet/web/personal/getCarMatchEntrance`
};

export const MessageCenterUrl = {
  NewMsgCount: `${config.host}/fleet/web/im/getNewMsgCount` // 获取会话列表
};
